import { Component } from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

@Component({
  selector: 'page-alerts',
  templateUrl: 'alerts.html'
})
export class AlertsPage{

  private asset: any = {};
  private alerts: any = [];

  constructor(public navCtrl: NavController,
              public navParams: NavParams) {
    //Getting the asset object from navigation parameters
    this.asset = navParams.get('asset');
    this.alerts = navParams.get('alerts');
    console.log(this.alerts)
  }

  ngOnInit() {

  }

  goBack(){
    // Go back to assets
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/alerts/alerts.ts